import slugify from "slugify";

export function generateInitialFromName(text: string) {
	if (!text) return;
	const exp = text.replace(/\s\s+/g, " ").split(" ");
	if (exp.length === 1) {
		return exp[0][0] + exp[0][1];
	} else if (exp.length > 1) {
		return exp[0][0] + exp[1][0];
	} else {
		return "SK";
	}
}
const generateSubdomain = (officeName: string) => {
	let result = officeName.toLowerCase();
	result = result.replace(/[\W_]+/g, "-");
	return result;
};

export const generateSlugBlog = (title: string) => {
	if (!title) return undefined;

	// let slug = slugify(title, {
	// 	lower: true,
	// 	// remove: /[~`#$%^&_+=*+~.(){}'"!:@?]/g,
	// 	remove: /[^\w\s-]/gi,
	// });

	// return slug;

	return title
		.toLowerCase() // Mengubah semua huruf menjadi huruf kecil
		.replace(/[^a-z0-9\s-]/g, "") // Menghapus karakter spesial, hanya menyisakan huruf, angka, spasi, dan '-'
		.trim() // Menghapus spasi di awal dan akhir string
		.replace(/\s+/g, "-") // Mengganti spasi dengan '-'
		.replace(/-+/g, "-"); // Mengganti tanda '-' yang berulang menjadi satu '-'
};

export { generateSubdomain };
